
import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";
import ApiBuilder from "@/api/ApiBuilder";
import { VenuesPageProps,FilterVenuesType ,GetSlotsByDateType, getdefaultArgs} from "@/types/interfaceType";

// Define types for your parameters
interface FetchVenuesParams {
    payload?: VenuesPageProps;
    page?:number | null |any
    callback?: (response?: any, error?: any) => void;
}

interface UserRecommendationArgs {
    payload?: {lat:Number,lng:Number,city?:String};
    callback?: (response: any) => void; // Optional callback
}

interface SearchLocationArgs {
    payload: {
        query: string;
        limit?: number;
        country?: string;
        lat?: number | null;
        lng?: number | null;
    };
    callback?: (response: any) => void;
}

interface TrendingVenuesArgs {
    payload?: {lat?:Number,lng?:Number,city?:String};
    callback?: (response: any) => void; // Optional callback
}

interface TrendingSportsArgs {
    payload?: {lat?:Number,lng?:Number,city?:String};
    callback?: (response: any) => void; // Optional callback
}

interface VenueAvailabilityArgs {
    payload?: {lat:Number,lng:Number,city?:String};
    callback?: (response: any) => void; // Optional callback
}
interface FilterVenuesArgs{
    payload?: FilterVenuesType;
    callback?: (response?: any, error?: any) => void;
}
interface FetchVenuesDetailsParams {
    pathparams?: String;
    data?:{lat?:Number,lng?:Number,city?:String};
    callback?: (response?: any, error?: any) => void;
}

interface GetApiParams {
    pathparams?: String;
    callback?: (response?: any, error?: any) => void;
}

interface GetSlotsByDateTypeArgs{
    pathparams?: string;
    payload?: GetSlotsByDateType;
    callback?: (response?: any, error?: any) => void;
}


interface nearByApiQueryParams {
    payload?: {
        lat: number,
        lng: number,
        radius?: number,
        locationDetailsrequired: boolean
    };
    callback?: (response?: any, error?: any) => void;
}

interface ValidateDirectBookingLinkParms {
    pathparams?: string;
    callback?: (response?: any, error?: any) => void;
}




export const fetchVenuesList = createAsyncThunk<any, FetchVenuesParams>(
    "venues/fetchVenuesList",
    async ({ payload,page, callback }, { rejectWithValue }) => {
        try {
            let res = await ApiBuilder.venuesList(payload);
            if (callback) {
                callback(res);
            }
            return res;
        } catch (error) {
            if (callback) {
                callback(error);
            }
            return rejectWithValue(error);
        }
    }
);


export const getVendorRegisterVenues = createAsyncThunk<any, FetchVenuesParams>(
    "venues/getVendorRegisterVenues",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            let res = await ApiBuilder.getVendorRegisterVenues(payload);
            if (callback) {
                callback(res);
            }
            return res;
        } catch (error) {
            if (callback) {
                callback(error);
            }
            return rejectWithValue(error);
        }
    }
);



export const fetchVenuesDetails = createAsyncThunk<any, FetchVenuesDetailsParams>(
    "venues/fetchVenuesDetails",
    async ({ pathparams, callback ,data}, { rejectWithValue }) => {
        try {
            let res = await ApiBuilder.venueDetailsList(pathparams,data);
            if (callback) {
                callback(res);
            }
            return res;
        } catch (error) {
            if (callback) {
                callback(error);
            }
            return rejectWithValue(error);
        }
    }
);
export const getCategories = createAsyncThunk<any, GetApiParams>(
    "venues/getCategories",
    async ({ pathparams, callback }, { rejectWithValue }) => {
        try {
            let res = await ApiBuilder.getCategories();
            if (callback) {
                callback(res);
            }
            return res;
        } catch (error) {
            if (callback) {
                callback(error);
            }
            return rejectWithValue(error);
        }
    }
);

export const getNearbyTurfs = createAsyncThunk<any, nearByApiQueryParams>(
    "venues/getNearbyTurfs",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            let res = await ApiBuilder.getNearbyTurfs(payload);
            if (callback) {
                callback(res);
            }
            return res;
        } catch (error) {
            if (callback) {
                callback(error);
            }
            return rejectWithValue(error);
        }
    }
);

export const filterVenues = createAsyncThunk<any, FilterVenuesArgs>(
    "venue/filterVenues",
    async ({ payload, callback }, { rejectWithValue }) => {
      try {
        const response = await ApiBuilder.filterVenues(payload);
        return response;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
  );

  export const getSlotsByDate = createAsyncThunk<any, GetSlotsByDateTypeArgs>(
    "venue/getSlotsByDate",
    async ({ payload,callback}, { rejectWithValue }) => {
      try {
        const response = await ApiBuilder.getSlotsByDate(payload);
        if (callback) {
            callback(response);
        }
        return response;
      } catch (error:any) {
        console.log("error:",error)
        return rejectWithValue(error);
      }
    }
  );


  export const validateDirectBookingLink=createAsyncThunk<any, ValidateDirectBookingLinkParms>(
    "venue/validateDirectBookingLink",
    async ({pathparams,callback}, { rejectWithValue }) => {
      try {
        const response = await ApiBuilder.validateDirectBookingLink(pathparams);
        if (callback) {
            callback(response);
        }
        return response;
      } catch (error:any) {
        console.log("error:",error)
        return rejectWithValue(error);
      }
    }
  );

  export const getDirectBookingLinkVenueSlotsByDate=createAsyncThunk<any, GetSlotsByDateTypeArgs>(
    "venue/getDirectBookingLinkVenueSlotsByDate",
    async ({pathparams,payload,callback}, { rejectWithValue }) => {
      try {
        const response = await ApiBuilder.getDirectBookingLinkVenueSlotsByDate(pathparams,payload);
        if (callback) {
            callback(response);
        }
        return response;
      } catch (error:any) {
        console.log("error:",error)
        return rejectWithValue(error);
      }
    }
  );




export const checkVenueAvailability=createAsyncThunk<any,VenueAvailabilityArgs>(
    "venue/checkVenueAvailability",
    async ({payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.checkVenueAvailability(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Something went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);

export const searchLocation = createAsyncThunk<any, SearchLocationArgs>(
    "venue/searchLocation",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.searchLocation(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Something went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);

export const getTrendingVenues=createAsyncThunk<any,TrendingVenuesArgs>(
    "venue/getTrendingVenues",
    async ({payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getTrendingVenues(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Something went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);


export const getUsersRecommendedVenues=createAsyncThunk<any, UserRecommendationArgs>(
    "venue/getUsersRecommendedVenues",
    async ({payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getUsersRecommendedVenues(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Something went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);



export const getVenuePricingRule=createAsyncThunk<any, getdefaultArgs>(
    "venue/getVenuePricingRule",
    async ({pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVenuePricingRule(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Something went wrong!";
            return rejectWithValue(errorMessage);
        }
    }
);


export const getTrendingSports=createAsyncThunk<any,TrendingSportsArgs>(
    "dashboard/getTrendingSports",
    async ({callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getTrendingSports();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error:any) {
            const errorMessage= error?.error || error?.response?.data?.message || error?.message || "Something went wrong!";

            return rejectWithValue(errorMessage);
        }
    }
);